<div class="flex min-h-screen flex-col">
  <app-header />
  <main>
    <router-outlet />
  </main>
  <app-footer class="z-20" />
</div>
